module.exports = __webpack_public_path__ + "static/logo-osa-white-f22c83efa83623dd93d80a28846aa40b.png";